import React from "react";
import Beneficios from "../../atoms/BeneficiosList";
import { StaticImage } from "gatsby-plugin-image";
import styled from "styled-components";
const Details = () => {
  return (
    <Wrapper className="user-account benefit-section product-detail">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h1 className="text-center pb-2">Seguro de auto</h1>
          </div>
          <div className="col-md-12 col-lg-5">
            <Beneficios />
          </div>
          <div className="col-md-12 col-lg-7 pl-lg-5">
            <div className="card">
              <div className="card-body px-4 px-md-5">
                <h5 className="text-center mb-1">
                  <span className="text-primary">¡5 años </span> en México como
                </h5>
                <h4 className="text-center mb-4">
                  <strong>
                    líder del{" "}
                    <span className="text-primary">mercado digital!</span>
                  </strong>
                </h4>
                <div className="row">
                  <div className="col-md-12">
                    <form>
                      <div className="row">
                        <div className="col-md-12 px-2">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Nombre(s)*"
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 px-2">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Apellido Paterno*"
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 px-2">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Apellido Materno*"
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 px-2">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Fecha de Nacimiento*"
                            />
                            <StaticImage
                              className="calendar-icon"
                              src="../../../assets/images/calendar-white.png"
                              alt="calendar"
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 px-2">
                          <label className="mr-2">Nacionalidad</label>
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="Mexicana"
                              name="Otro"
                              checked
                            />
                            <label for="Mexicana">Mexicana</label>
                          </div>
                          <div className="custom-radio d-inline-block ml-2">
                            <input type="radio" id="Otro" name="Otro" />
                            <label for="Otro">Otro</label>
                          </div>
                        </div>
                        <div className="col-sm-6 px-2">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Número telefónico*"
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 px-2">
                          <label
                            className="mr-4 pr-
                                             "
                          >
                            {" "}
                            Género*
                          </label>
                          <div className="custom-radio d-inline-block">
                            <input type="radio" id="fem" name="gender" />
                            <label for="fem">Fem.</label>
                          </div>
                          <div className="custom-radio d-inline-block ml-masc">
                            <input
                              type="radio"
                              id="masc"
                              name="gender"
                              checked
                            />
                            <label for="masc">Masc.</label>
                          </div>
                        </div>
                        <div className="col-sm-6 px-2">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Correo electrónico*"
                            />
                          </div>
                        </div>
                        <div className="col-md-12 text-center">
                          <button
                            type="button"
                            className="btn btn-warning px-5 mt-2"
                          >
                            Continuar
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Details;

const Wrapper = styled.section`
  .mr-4,
  .mx-4 {
    margin-right: 2.8rem !important;
  }
  .ml-masc {
    margin-left: 2.2rem;
  }
`;
